export const Capitalize = (letter) => {
  return letter.charAt(0).toUpperCase() + letter.slice(1);
};
